<template>
    <div class="new-job">
        <form
            action=""
            @submit.prevent="saveJob()"
        >
            <div class="row">
                <div class="col-sm-12 col-md-8">
                    <div class="form-group">
                        <label for="name">Job Name:</label>
                        <input
                            name="name"
                            v-model="job.name"
                            id="name"
                            class="form-control"
                            required
                        >
                        <small
                            class="form-error"
                            v-if="errors.name"
                        >{{ errors.name[0] }}</small>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2">
                    <div class="form-group">
                        <label for="colour">Job Colour:</label>
                        <input
                            name="colour"
                            type="color"
                            v-model="job.color"
                            id="colour"
                            class="form-control"
                            required
                        >
                        <small
                            class="form-error"
                            v-if="errors.colour"
                        >{{ errors.colour[0] }}</small>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2">
                    <div class="form-group">
                        <label for="type">Job Type:</label>
                        <span style="display: block; width: 100%;">
                            <input
                                name="type"
                                type="checkbox"
                                v-model="job.is_call_out"
                                id="type"
                                class="form-control"
                                style="display: inline-block; width: auto;"
                            >
                            Is call out?
                        </span>
                        <small
                            class="form-error"
                            v-if="errors.is_call_out"
                        >{{ errors.is_call_out[0] }}</small>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <label for="customer">Customer:</label>
                        <customer-search
                            ref="customerSearch"
                            :customer="job.customer"
                            @change="customerChanged"
                        />
                        <small
                            class="form-error"
                            v-if="errors.customer_id"
                        >{{ errors.customer_id[0] }}</small>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div
                        class="form-group"
                    >
                        <label for="site">Site:</label>
                        <site-search
                            ref="siteSearch"
                            :site="job.site"
                            @change="siteChanged"
                        />
                        <small
                            class="form-error"
                            v-if="errors.site_id"
                        >{{ errors.site_id[0] }}</small>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <label for="first_name">First name:</label>
                        <input
                            name="first_name"
                            v-model="job.first_name"
                            id="first_name"
                            class="form-control"
                            :required="isJobNew"
                        >
                        <small
                            class="form-error"
                            v-if="errors.first_name"
                        >{{ errors.first_name[0] }}</small>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <label for="last_name">Last name:</label>
                        <input
                            name="last_name"
                            v-model="job.last_name"
                            id="last_name"
                            class="form-control"
                            :required="isJobNew"
                        >
                        <small
                            class="form-error"
                            v-if="errors.last_name"
                        >{{ errors.last_name[0] }}</small>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="important_info">Important Info:</label>
                <textarea
                    name="important_info"
                    v-model="job.important_info"
                    id="important_info"
                    class="form-control"
                    rows="4"
                />
                <small
                    class="form-error"
                    v-if="errors.important_info"
                >{{ errors.important_info[0] }}</small>
            </div>

            <div class="form-group">
                <label for="description">Job Description:</label>
                <textarea
                    name="description"
                    v-model="job.description"
                    id="description"
                    class="form-control"
                    rows="4"
                    placeholder="Date/times stated? Who have you spoke to? Cost agreed? Quote number? Any further information..."
                    required
                />
                <small
                    class="form-error"
                    v-if="errors.description"
                >{{ errors.description[0] }}</small>
            </div>
            <div class="form-group">
                <label>Times:</label>
                <table class="table table-light-head">
                    <thead>
                        <th>Start:</th>
                        <th />
                        <th>End:</th>
                        <th>Engineer:</th>
                        <th v-if="job.time_slots && job.time_slots.length > 1" />
                    </thead>
                    <tbody>
                        <tr
                            v-for="(slot, index) in job.time_slots"
                            :key="index"
                        >
                            <td>
                                <date-picker
                                    v-model="slot.start"
                                    required
                                />
                                <small
                                    class="form-error"
                                    v-if="errors['time_slots.'+index+'.start']"
                                >{{ errors['time_slots.'+index+'.start'][0] }}
                                </small>
                            </td>
                            <td>-</td>
                            <td>
                                <date-picker
                                    v-model="slot.end"
                                    required
                                />
                                <small
                                    class="form-error"
                                    v-if="errors['time_slots.'+index+'.end']"
                                >{{ errors['time_slots.'+index+'.end'][0] }}
                                </small>
                            </td>
                            <td>
                                <div class="form-group">
                                    <select
                                        name="user"
                                        v-model="slot.user_id"
                                        id="user"
                                        class="form-control"
                                        placeholder="Engineer"
                                        @change="timeSlotUserChanged(index)"
                                        v-show="canAssignEngineers"
                                        required
                                    >
                                        <option
                                            v-for="engineer in engineers"
                                            :key="engineer.id"
                                            :value="engineer.id"
                                        >
                                            {{ engineer.name }}
                                        </option>
                                    </select>
                                    <input 
                                        type="text" 
                                        readonly 
                                        :value="slot.user.name" 
                                        v-show="!canAssignEngineers" 
                                        v-if="slot.user.name"
                                    >
                                    <small
                                        class="form-error"
                                        v-if="errors['time_slots.'+index+'.user_id']"
                                    >
                                        {{ errors['time_slots.'+index+'.user_id'][0] }}
                                    </small>
                                </div>
                            </td>
                            <td v-if="job.time_slots.length > 1">
                                <button
                                    @click.prevent="removeATime(index)"
                                    class="btn btn-sm btn-outline-danger"
                                >
                                    <i class="fa fa-times" />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="5">
                                <button
                                    class="btn btn-sm btn-outline-primary"
                                    @click.prevent="addATime()"
                                >
                                    <i class="fa fa-plus" /> Add a time
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="form-group">
                <label>Forms:</label>
                <table
                    class="table table-light-head"
                    v-if="job.id"
                >
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Doc No.</th>
                            <th>Type</th>
                            <th>Last Updated</th>
                            <th>
                                <!-- options -->
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(form, i) in job.forms"
                            :key="i"
                        >
                            <td>{{ form.name }}</td>
                            <td>{{ form.doc_no || '-' }}</td>
                            <td>{{ form.nice_type }}</td>
                            <td>{{ form.updated_at || '-' }}</td>
                            <td>
                                <router-link
                                    :to="{name:'office.forms.new', query: {type: form.type, job_id: job.id}}"
                                    class="btn btn-sm btn-info"
                                    v-if="!form.id"
                                >
                                    <i class="fa fa-pencil-alt" />
                                </router-link>
                                <router-link
                                    :to="{name: 'office.forms.edit', params: {id: form.id}}"
                                    class="btn btn-sm btn-info"
                                    v-if="form.id"
                                >
                                    <i class="fa fa-pencil-alt" />
                                </router-link>
                                <router-link
                                    :to="{name:'office.forms.preview', params: {id: form.id}}"
                                    class="btn btn-sm btn-info"
                                    v-if="form.id"
                                >
                                    <i class="fa fa-print" />
                                </router-link>
                                <button
                                    class="btn btn-sm btn-outline-danger"
                                    @click.prevent="deleteForm(i)"
                                    type="button"
                                >
                                    <i class="fa fa-times" />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <select
                                    name="form_type"
                                    id="form_type"
                                    v-model="newFormType"
                                    class="form-control"
                                >
                                    <option
                                        v-for="type in filteredFormTypes"
                                        :key="type.value"
                                        :value="type.value"
                                    >
                                        {{ type.name }}
                                    </option>
                                </select>
                            </td>
                            <td colspan="5">
                                <button
                                    class="btn btn-sm btn-outline-primary"
                                    @click.prevent="addAForm()"
                                    type="button"
                                >
                                    <i class="fa fa-plus" /> Add a form
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <p
                    class="error"
                    v-if="!job.id"
                >
                    Save the job first to add forms
                </p>
            </div>

            <div class="form-group col-sm-12 col-md-6">
                <label for="site">Job Status:</label>
                <select
                    name="status"
                    v-model="job.status"
                    id="status"
                    class="form-control"
                    placeholder="Status"
                    required
                >
                    <option
                        v-for="status in statuses"
                        :key="status.value"
                        :value="status.value"
                    >
                        {{ status.name }}
                    </option>
                </select>
                <small
                    class="form-error"
                    v-if="errors.status"
                >{{ errors.status[0] }}</small>
            </div>

            <div
                class="row"
                v-if="job.id"
            >
                <div class="form-group col-12 col-md-3">
                    <label for="invoiced_at">Invoiced On:</label>
                    <date-picker
                        v-model="job.invoiced_at"
                        id="invoiced_at"
                        :options="{format: 'L'}"
                        required
                    />
                    <small
                        class="form-error"
                        v-if="errors['invoiced_at']"
                    >
                        {{ errors['invoiced_at'][0] }}
                    </small>
                </div>
                <div class="form-group col-12 col-md-3">
                    <label for="invoiced_by_id">Invoiced By:</label>
                    <select
                        name="invoiced_by_id"
                        v-model="job.invoiced_by_id"
                        id="invoiced_by_id"
                        class="form-control"
                        placeholder="Staff"
                    >
                        <option
                            :value="null"
                            disabled
                        >
                            Select user
                        </option>
                        <option
                            v-for="u in officeStaff"
                            :key="u.id"
                            :value="u.id"
                        >
                            {{ u.name }}
                        </option>
                    </select>
                    <small
                        class="form-error"
                        v-if="errors['invoiced_by_id']"
                    >
                        {{ errors['invoiced_by_id'][0] }}
                    </small>
                </div>
            </div>

            <div class="form-group">
                <p v-if="job.created_by_user && job.created_at">
                    Created by {{ job.created_by_user.name }} at {{ job.created_at.format(config.format) }}
                </p>
                <p v-if="job.updated_by_user && job.updated_at">
                    Last updated by {{ job.updated_by_user.name }} at {{ job.updated_at.format(config.format) }}
                </p>
            </div>

            <div
                class="form-group"
                v-if="job.customer_id "
            >
                <label>Notes:</label>
                <comments
                    v-if="showNotes"
                    :model-id="job.customer_id"
                    model-type="App\Customer"
                />
                <a
                    href="#"
                    v-if="!showNotes"
                    @click.prevent="showNotes = true"
                >Click to show notes</a>
            </div>

            <div class="form-group">
                <button
                    type="submit"
                    class="btn btn-success"
                >
                    Save Job
                </button>
                <button
                    type="button"
                    @click="deleteJob()"
                    class="btn btn-danger"
                >
                    Delete Job
                </button>
                <button
                    type="button"
                    @click="newJob()"
                    class="btn btn-info"
                >
                    New Job
                </button>
                <button
                    type="button"
                    @click="showNotes = !showNotes"
                    class="btn btn-info"
                    v-if="job.customer_id"
                >
                    Toggle Notes
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import JobService from "../services/JobService";
import CustomerService from "../services/CustomerService";
import FormService from "../services/FormService";
import UsersService from "../services/UsersService";
import DatePicker from "./DateTimePickerComponent";
import CustomerSearch from "./CustomerSearch";
import SiteSearch from "./SiteSearchComponent";
import * as moment from "moment";
import * as Job from "../include/Job";
import * as Form from "../include/Form";

export default {
    components: {
        DatePicker,
        CustomerSearch,
        SiteSearch,
    },

    data() {
        return {
            statuses: Job.statuses,
            job: {
                time_slots: [],
                customer: {},
                forms: [],
                status: Job.statuses[0].value,
                invoiced_at: null,
                first_name: '',
                last_name: '',
            },
            errors: {},
            showNotes: false,
            newFormType: null,
            officeStaff: [],
            engineers: [],
            sites: [],
            user: window.AuthService.user,
        };
    },

    computed: {
        isJobNew() {
            return !this.job.id;
        },

        isEngineerUser() {
            return this.user.engineer_access;
        },

        canAssignEngineers() {
            return this.user.office_access || this.user.admin_access;
        },
        filteredFormTypes() {
            return Form.types.filter(t => {
                if (!t.name.toLowerCase().includes('certificate')) {
                    return true;
                }
                if (this.$route.path.includes('/engineer')) {
                    return false;
                }

                return true;
            });
        },
    },

    mounted() {
        this.getEngineers().then(() => {
            this.addATime();
        });

        this.getOfficeStaff();

        if (this.$route.query.customer_id) {
            const customerId = this.$route.query.customer_id;
            CustomerService.get(customerId).then(response => {
                this.customerChanged(response.data);
            });
        }

        this.newFormType = this.filteredFormTypes[0].value;
    },

    methods: {
        customerChanged(customer) {
            if (customer.overdue) {
                const confirm = window.confirm(`This customer's account is overdue, continue with new job?`);
                if (!confirm) {
                    this.job.customer = null;
                    this.$refs.customerSearch.clear();
                    return;
                }
            }
            if (customer.proforma) {
                const confirm = window.confirm(`This customer's account is proforma/cash, continue with new job?`);
                if (!confirm) {
                    this.job.customer = null;
                    this.$refs.customerSearch.clear();
                    return;
                }
            }
            this.showNotes = false;
            if (customer === null) {
                this.job.customer = {};
                this.job.customer_id = null;
                this.job.site_id = null;
            } else {
                this.job.customer = customer;
                this.job.customer_id = customer.id;
                if (!this.job.site_id && this.job.customer.sites.length) {
                    this.job.site_id = this.job.customer.sites[0].id;
                    this.$refs.siteSearch.setResults(customer.sites);
                }
            }
        },

        siteChanged (site) {
            if (site === null) {
                this.job.site_id = null;
            } else {
                if (site.customer_id != this.job.customer_id) {
                    this.job.customer = site.customer;
                    this.job.customer_id = site.customer.id;
                }
                this.job.site_id = site.id;
                this.job.site = site;
            }
        },

        getEngineers() {
            return new Promise((fulfill, reject) => {
                UsersService.engineers().then(
                    xhr => {
                        this.engineers = xhr.data;
                        fulfill();
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        getOfficeStaff() {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    xhr => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        setJob(job) {
            this.job = job;
            for (let i = 0; i < this.job.time_slots.length; i++) {
                this.timeSlotUserChanged(i);
            }
        },

        timeSlotUserChanged(index) {
            const timeSlot = this.job.time_slots[index];
            // Set new user based on id
            if (!timeSlot.user || timeSlot.user_id !== timeSlot.user.id) {
                timeSlot.user = this.engineers.find(e => {
                    return e.id === timeSlot.user_id;
                });
                return;
            }
            // Set user based on user object
            if (timeSlot.user) {
                let inEngineers = this.engineers.findIndex(e => {
                    return e.id === timeSlot.user.id;
                });
                if (inEngineers === -1) {
                    this.engineers.push(timeSlot.user);
                }
                this.job.time_slots[index].user_id = timeSlot.user.id;
            } else {
                // Cannot set the object
                this.job.time_slots[index].user_id = null;
            }
        },

        saveJob() {
            if (this.job.id) {
                JobService.update(this.job).then(
                    xhr => {
                        this.jobSaved(xhr);
                    },
                    err => {
                        this.saveJobError(err);
                    }
                );
            } else {
                JobService.create(this.job).then(
                    xhr => {
                        this.jobSaved(xhr);
                        this.$emit('created');
                    },
                    err => {
                        this.saveJobError(err);
                    }
                );
            }
        },

        jobSaved() {
            this.clearJob();
            alert("Job saved successfully");
            this.$emit('saved');
        },

        saveJobError(xhr) {
            if (xhr.response.data.errors) {
                this.errors = xhr.response.data.errors;
                alert("Please check the job form for errors");
            } else {
                alert("There was a problem saving the job");
            }
        },

        clearJob() {
            this.job = {
                time_slots: [],
                customer: {},
                forms: [],
                status: this.statuses[0].value,
                first_name: '',
                last_name: '',
            };
            this.sites = [];
            this.addATime();
        },

        clear() {
            this.clearJob();
        },

        addATime(date = null) {
            if (this.job.time_slots.length) {
                const lastSlot = this.job.time_slots[
                    this.job.time_slots.length - 1
                ];
                let engineer = lastSlot.user ? lastSlot.user : this.engineers[0];
                if (!this.canAssignEngineers) {
                    engineer = {...this.user};
                }

                this.job.time_slots.push({
                    user: engineer,
                    user_id: engineer.id,
                    start: moment(lastSlot.start),
                    end: moment(lastSlot.end)
                });
            } else {
                date = date
                    ? date
                    : moment()
                        .add(1, "hour")
                        .startOf("hour");

                let engineer = this.engineers[0];
                if (this.isEngineerUser) {
                    engineer = {...this.user};
                }

                this.job.time_slots.push({
                    start: date,
                    end: moment(date).add(30, "minutes"),
                    user: engineer,
                    user_id: engineer.id
                });
            }
            this.timeSlotUserChanged(this.job.time_slots.length - 1);
            this.$forceUpdate();
        },

        removeATime(index) {
            this.job.time_slots.splice(index, 1);
            this.$forceUpdate();
        },

        addAForm() {
            const form = {
                job_id: this.job.id,
                customer_id: this.job.customer_id,
                site_id: this.job.site_id,
                type: this.newFormType,
                add_form_fields: true,
            };
            FormService.nextNo().then(res => {
                form.doc_no = res.data;
                FormService.create(form).then(
                    res => {
                        this.job.forms.push(res.data);
                    },
                    () => {
                        alert("Error: Could not create new form");
                    }
                );
            });
        },

        deleteForm(i) {
            const form = this.job.forms[i];
            if (form.id) {
                if (confirm("Are you sure you want to delete this form?")) {
                    FormService.delete(form).then(
                        () => {
                            this.job.forms.splice(i);
                        },
                        () => {
                            alert("Error: could not delete form");
                        }
                    );
                }
            } else {
                this.job.forms.splice(i);
            }
        },

        deleteJob() {
            const confirm = window.confirm(
                "Are you sure you want to delete this job?"
            );
            if (!confirm) {
                return;
            }
            if (this.isJobNew) {
                this.newJob();
                this.$emit('deleted');
            } else {
                JobService.delete(this.job).then(
                    () => {
                        this.newJob();
                        this.$emit('deleted');
                    },
                    () => {
                        alert("Error: Job could not be deleted");
                    }
                );
            }
        },

        newJob() {
            this.clearJob();
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/NewJobComponent.vue